import React from 'react';
import { motion } from 'framer-motion';
import { FiArrowDown } from 'react-icons/fi';
import StarsBackground from '../../images/stars2.gif';
import './AboutMe.css';

const AboutMe = () => {
  return (
    <div className="about-container">
      {/* Decorative Background */}
      <motion.div
        className="about-bg"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 0.3 }}
        transition={{ duration: 1.5 }}
        viewport={{ once: false, margin: "-200px" }}
        style={{ backgroundImage: `url(${StarsBackground})` }}
      />

      <motion.div
        className="glass-panel about-card"
        initial={{ opacity: 0, y: 100, rotateX: 20 }}
        whileInView={{ opacity: 1, y: 0, rotateX: 0 }}
        transition={{ type: "spring", stiffness: 100, damping: 20, duration: 0.8 }}
        viewport={{ once: true, margin: "-100px" }}
      >
        <div className="about-header">
          <h2 className="text-gradient">Hello World!</h2>
          <div className="divider"></div>
        </div>

        <div className="about-body">
          <p className="lead-text">
            Let me tell you a little about myself. My name is <strong className="highlight">Rooshhil Patel</strong> and I am a Software Engineer, an Application Developer, and most importantly, a Problem Solver.
          </p>
          <p className="secondary-text">
            I consider computer science as the modern day alchemy, converting nothing into something!
          </p>
        </div>

        <motion.div
          className="about-footer"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 1 }}
          viewport={{ once: true }}
        >
          <span>Check out the cool stuff I've done below.</span>
          <motion.div
            animate={{ y: [0, 10, 0] }}
            transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
            className="arrow-container text-gradient"
            onClick={() => document.getElementById('projectsBlock')?.scrollIntoView({ behavior: 'smooth' })}
            style={{ cursor: 'pointer' }}
          >
            <FiArrowDown />
          </motion.div>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default AboutMe;
